import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledMagnifyingGlassIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_16793_3905",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M13.5 1C18.7467 1 23 5.25329 23 10.5C23 15.7467 18.7467 20 13.5 20C8.25329 20 4 15.7467 4 10.5C4 5.25329 8.25329 1 13.5 1ZM13.5 4.09961C9.96538 4.09961 7.09961 6.96538 7.09961 10.5C7.09962 14.0346 9.96539 16.9004 13.5 16.9004C17.0346 16.9004 19.9004 14.0346 19.9004 10.5C19.9004 6.96539 17.0346 4.09962 13.5 4.09961Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 1C18.7467 1 23 5.25329 23 10.5C23 15.7467 18.7467 20 13.5 20C8.25329 20 4 15.7467 4 10.5C4 5.25329 8.25329 1 13.5 1ZM13.5 4.09961C9.96538 4.09961 7.09961 6.96538 7.09961 10.5C7.09962 14.0346 9.96539 16.9004 13.5 16.9004C17.0346 16.9004 19.9004 14.0346 19.9004 10.5C19.9004 6.96539 17.0346 4.09962 13.5 4.09961Z",
			fill: "#4B7987"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 4.09961L13.5 3.09961H13.5V4.09961ZM7.09961 10.5H6.09961V10.5L7.09961 10.5ZM13.5 16.9004V17.9004H13.5L13.5 16.9004ZM19.9004 10.5L20.9004 10.5V10.5H19.9004ZM13.5 1V2C18.1944 2 22 5.80558 22 10.5H23H24C24 4.70101 19.299 0 13.5 0V1ZM23 10.5H22C22 15.1944 18.1944 19 13.5 19V20V21C19.299 21 24 16.299 24 10.5H23ZM13.5 20V19C8.80558 19 5 15.1944 5 10.5H4H3C3 16.299 7.70101 21 13.5 21V20ZM4 10.5H5C5 5.80558 8.80558 2 13.5 2V1V0C7.70101 0 3 4.70101 3 10.5H4ZM13.5 4.09961V3.09961C9.41309 3.09961 6.09961 6.41309 6.09961 10.5H7.09961H8.09961C8.09961 7.51766 10.5177 5.09961 13.5 5.09961V4.09961ZM7.09961 10.5L6.09961 10.5C6.09962 14.5869 9.4131 17.9004 13.5 17.9004V16.9004V15.9004C10.5177 15.9004 8.09962 13.4823 8.09961 10.5L7.09961 10.5ZM13.5 16.9004L13.5 17.9004C17.5869 17.9004 20.9004 14.5869 20.9004 10.5L19.9004 10.5L18.9004 10.5C18.9004 13.4823 16.4823 15.9004 13.5 15.9004L13.5 16.9004ZM19.9004 10.5H20.9004C20.9004 6.4131 17.5869 3.09962 13.5 3.09961L13.5 4.09961L13.5 5.09961C16.4823 5.09962 18.9004 7.51767 18.9004 10.5H19.9004Z",
			fill: "#00AF71",
			mask: "url(#path-1-inside-1_16793_3905)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.08081 16.0809C6.58849 15.5732 7.412 15.5732 7.91968 16.0809C8.42707 16.5886 8.42726 17.4122 7.91968 17.9197L2.91968 22.9197C2.41209 23.4273 1.58852 23.4271 1.08081 22.9197C0.573129 22.4121 0.573129 21.5886 1.08081 21.0809L6.08081 16.0809Z",
			fill: "#4B7987",
			stroke: "#00AF71"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 7L13.5 8.1547V10.4641L11.5 11.6188L9.5 10.4641V8.1547L11.5 7Z",
			fill: "white",
			stroke: "#00AF71"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 7L17.5 8.1547V10.4641L15.5 11.6188L13.5 10.4641V8.1547L15.5 7Z",
			fill: "white",
			stroke: "#00AF71"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 10.5L15.5 11.6547V13.9641L13.5 15.1188L11.5 13.9641V11.6547L13.5 10.5Z",
			fill: "white",
			stroke: "#00AF71"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledMagnifyingGlassIcon);
const Memo = memo(ForwardRef);
export default Memo;
